const resourceDocs = [
  {
    slug: 'cyra',
    title: 'Cyra AI Assistant',
    desc: 'Your virtual security analyst for real-time analysis, incident reports, and actionable next steps.',
    type: 'datasheet',
    file: '/docs/cylerian-cyra-datasheet.pdf'
  },
  {
    slug: 'siem-xdr',
    title: 'SIEM & XDR',
    desc: 'Unified SIEM and XDR for detection and response across your estate.',
    type: 'datasheet',
    file: '/docs/cylerian-siem-xdr.pdf'
  },
  {
    slug: 'exposure-management-overview',
    title: 'Exposure Management',
    desc: 'Continuous visibility and prioritized remediation across your attack surface.',
    type: 'datasheet',
    file: '/docs/cylerian-exposure-management-overview.pdf'
  },
  {
    slug: 'identity-email-protection',
    title: 'Identity & Email Protection',
    desc: 'AI-native email security with identity threat detection and response.',
    type: 'datasheet',
    file: '/docs/cylerian-identity-email-protection.pdf'
  },
  {
    slug: 'ir-forensics',
    title: 'Incident Response & Forensics',
    desc: 'Full-scope incident response and forensics on a single platform.',
    type: 'datasheet',
    file: '/docs/cylerian-ir-forensics.pdf'
  },
  {
    slug: 'partner-overview',
    title: 'Partner Overview',
    desc: 'Enterprise-grade cybersecurity in a unified platform.',
    type: 'datasheet',
    file: '/docs/cylerian-partner-overview.pdf'
  },
  {
    slug: 'platform-overview',
    title: 'Platform Overview',
    desc: 'One unified platform for security, observability, and operations.',
    type: 'datasheet',
    file: '/docs/cylerian-platform-datasheet.pdf'
  },
  {
    slug: 'compliance',
    title: 'Compliance',
    desc: 'Continuous compliance monitoring and audit-ready reporting.',
    type: 'datasheet',
    file: '/docs/cylerian-compliance.pdf'
  },
  {
    slug: 'cloud-security',
    title: 'Cloud Security',
    desc: 'Unified protection and visibility across your cloud workloads and services.',
    type: 'datasheet',
    file: '/docs/cylerian-cloud-security.pdf'
  },
  {
    slug: 'dns-sensor',
    title: 'DNS Sensor',
    desc: 'Endpoint DNS filtering and content blocking, without the middlebox.',
    type: 'datasheet',
    file: '/docs/cylerian-dns-sensor.pdf'
  },
  {
    slug: 'case-study',
    title: 'Cylerian Case Study',
    desc: 'Ransomware Attack Prevention',
    type: 'casestudy',
    file: '/docs/cylerian-case-study.pdf'
  },
  {
    slug: 'exela-case-study',
    title: 'Cylerian Case Study',
    desc: 'Exela Pharma Sciences Case Study',
    type: 'casestudy',
    file: '/docs/cylerian-exela-case-study.pdf'
  }
];

export default resourceDocs;
